import React from 'react';
import { FaEllipsisV } from 'react-icons/fa';
import {
  UsersListOptions,
  UsersListOptionsAdmin,
} from '../../../assets/constants/strings';

const UserOptions = ({ index, handleOption, isAdmin, numberOfAdmin }) => {
  const listOptions = isAdmin ? UsersListOptionsAdmin : UsersListOptions;

  return (
    <div className='users-card__options dropdown'>
      <div
        id={`card-options-dropdown-${index}`}
        data-toggle='dropdown'
        aria-haspopup='true'
        aria-expanded='false'
        title='Actions'
      >
        <FaEllipsisV className='users-card__options__icon' />
      </div>
      <div
        className='dropdown-menu dropdown-menu-right'
        aria-labelledby={`#card-options-dropdown-${index}`}
      >
        {listOptions.map((option, i) => (
          <div
            key={i}
            className='dropdown-item active-override'
            title={
              {
                0:
                  isAdmin &&
                  numberOfAdmin === 1 &&
                  'Can not delete only Admin.',
                1: isAdmin && numberOfAdmin === 1 && 'Can not make Basic.',
              }[i] || option.text
            }
            onClick={() => handleOption(option.value)}
          >
            {option.icon} {option.text}
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserOptions;
